import React from 'react';
import MemberForm from '../components/MemberForm'
import ActivateMemberForm from '../components/ActivateMemberForm'

import axios from 'axios'
import { Table, Input, Button,Form,DatePicker,Switch,Collapse,Typography,Space,Divider,Popover,Popconfirm,message,Descriptions,Modal,Spin,Alert,Select } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,PrinterOutlined,DownloadOutlined,FundViewOutlined,EditOutlined,WalletFilled,LoadingOutlined,DownOutlined,UpOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import { ReportEmailControls, submitReportWithEmail, reportSearchButtonLabel, REPORT_KEYS, initialReportEmailState } from '../reportEmailUtils';
import { MemberBalancesJournalAlert } from '../journalReportUtils';
import ReactToPrint from 'react-to-print';
import * as reactstrp from 'reactstrap';
import moment from 'moment';

import {
  Col,
  Row,
} from 'reactstrap';
import ReactExport from "@ibrahimrahmani/react-export-excel";
import '../tablestyle.css'; // Create this CSS file for custom styles
const { RangePicker } = DatePicker;

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const { Title } = Typography;
const dateFormat = 'DD/MM/YYYY';
const FormItem=Form.Item;
const { Search } = Input;
const { Option } = Select;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function callback(key) {
  console.log(key);
}

const MEMBER_SUMMARY_COLUMN_COUNT = 13;

const MoneyCell = ({ value }) => (
  <CurrencyFormat
    value={Number(value || 0).toFixed(2)}
    displayType="text"
    thousandSeparator
  />
);

const MemberSummaryBreakdown = ({ breakdown, reportBasis }) => {
  if (!breakdown || breakdown.length === 0) {
    return (
      <Alert
        type="info"
        showIcon
        message="No GeneralJournal lines in this period for mapped subaccounts."
        style={{ margin: 8 }}
      />
    );
  }

  return (
    <div style={{ padding: '8px 12px', background: '#fafafa' }}>
      {reportBasis ? (
        <Alert type="info" showIcon message="How the report total is built" description={reportBasis} style={{ marginBottom: 12 }} />
      ) : null}
      {breakdown.map((section) => (
        <div key={section.subaccount_key} style={{ marginBottom: 16 }}>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>
            {section.subaccount_label}
            {' — report total '}
            <MoneyCell value={section.total} />
            {section.line_count != null && section.line_count > 0 ? (
              <span style={{ fontWeight: 400, marginLeft: 8 }}>
                ({section.line_count} GL entr{section.line_count === 1 ? 'y' : 'ies'})
              </span>
            ) : null}
          </div>
          {section.balance_formula ? (
            <div style={{ fontSize: 12, color: '#555', marginBottom: 8 }}>{section.balance_formula}</div>
          ) : null}
          {section.note ? (
            <Alert type="warning" showIcon message={section.note} style={{ marginBottom: 8 }} />
          ) : null}
          {section.lines && section.lines.length > 0 ? (
          <reactstrp.Table size="sm" bordered responsive>
            <thead>
              <tr>
                <th>Date</th>
                <th>Jnl #</th>
                <th>Voucher</th>
                <th>Account</th>
                <th>Description</th>
                <th>Reference</th>
                <th className="align-right">Debit</th>
                <th className="align-right">Credit</th>
                <th className="align-right">Net</th>
                <th className="align-right">Running balance</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ background: '#f0f5ff' }}>
                <td colSpan={9} style={{ fontStyle: 'italic' }}>Starting balance (before first line in this report)</td>
                <td className="align-right"><MoneyCell value={0} /></td>
              </tr>
              {section.lines.map((line, idx) => (
                <tr key={`${section.subaccount_key}-${line.id || idx}`}>
                  <td>{line.date || '—'}</td>
                  <td>{line.journal_no || '—'}</td>
                  <td>{line.voucher_no ? line.voucher_no : '—'}</td>
                  <td>
                    {line.ledger_account_name || '—'}
                    {line.ledger_account_code ? (
                      <span style={{ color: '#666' }}> ({line.ledger_account_code})</span>
                    ) : null}
                  </td>
                  <td>{line.description || '—'}</td>
                  <td>{line.reference || '—'}</td>
                  <td className="align-right"><MoneyCell value={line.debit} /></td>
                  <td className="align-right"><MoneyCell value={line.credit} /></td>
                  <td className="align-right"><MoneyCell value={line.net} /></td>
                  <td className="align-right" style={{ fontWeight: 600 }}>
                    <MoneyCell value={line.running_balance} />
                  </td>
                </tr>
              ))}
              <tr style={{ background: '#e6f7e6', fontWeight: 'bold' }}>
                <td colSpan={8} className="align-right">
                  Sum of line nets → report total
                </td>
                <td className="align-right"><MoneyCell value={section.sum_of_net} /></td>
                <td className="align-right"><MoneyCell value={section.total} /></td>
              </tr>
            </tbody>
          </reactstrp.Table>
          ) : null}
        </div>
      ))}
    </div>
  );
};

var token= ''
var sacco= ''
var bizuserid= ''

class ReportToPrint extends React.Component {

  state = {
    ...initialReportEmailState(),
    companyprofile:{},
  };

  componentDidMount(){

    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
       bizuserid= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })
    })

  }
  //calculate total savings
  calculateTotalSavings=()=>{
    var Total=0
    this.props.members.map(
      (item)=>{
        Total+=Number(item.savings_balance)
      })
    return Total;

  }

  calculateTotalShares=()=>{
    var Total=0
    this.props.members.map(
      (item)=>{
        Total+=Number(item.sharesamount_balance)
      })
    return Total;

  }

  calculateTotalDef=()=>{
    var Total=0
    this.props.members.map(
      (item)=>{
        Total+=Number(item.fixed_deposit_balance)
      })
    return Total;

  }


  calculateTotalsavingssec=()=>{
    var Total=0
    this.props.members.map(
      (item)=>{
        Total+=Number(item.savingsloan_security_balance)
      })
    return Total;

  }

  calculateTotalsharessec=()=>{
    var Total=0
    this.props.members.map(
      (item)=>{
        Total+=Number(item.sharesloan_security_balance)
      })
    return Total;
  }


  calculateTotal_loanbalance=()=>{
    var Total=0
    this.props.members.map(
      (item)=>{
        Total+=Number(item.loan_balance)
      })
    return Total;
  }

  calculateTotal_loaninterestbalance=()=>{
    var Total=0
    this.props.members.map(
      (item)=>{
        Total+=Number(item.loaninterest_balance)
      })
    return Total;
  }

  //neww herees
  calculateTotal_saving_interestbalance=()=>{
    var Total=0
    this.props.members.map(
      (item)=>{
        Total+=Number(item.saving_interestbalance)
      })
    return Total;
  }

  render() {
    return (
      <div style={{padding:20}}>
        <style>
        {`@media print {
          @page { size: landscape; }
        }`}
        </style>
         <Row> 
              <Col xs="2" sm="2" lg="2">
              <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
            
                </Col>
                <Col xs="6" sm="6" lg="6">
                <h3>{this.state.companyprofile.sacco_name}</h3>
                <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                {
                this.state.companyprofile.RegisteredPhoneNumber2==""?
                "":","+this.state.companyprofile.RegisteredPhoneNumber2
                }
                {
                this.state.companyprofile.RegisteredPhoneNumber3==""?
                "":","+this.state.companyprofile.RegisteredPhoneNumber3
                }
                </h6>               
                <h5>Email: {this.state.companyprofile.company_email}</h5>
                <h5>Wesite: {this.state.companyprofile.website}</h5>
                <h5>{this.state.companyprofile.box_number}</h5>
              
                </Col>

     </Row>

           <h3 style={{display: 'flex',justifyContent:'center', alignItems:'center',fontWeight:'bolder'}}>MEMBER SUMMARY  REPORT</h3>

           <reactstrp.Table bordered>
                      <thead>
                        <tr>
                        <th>No.</th>

                          <th>Account Number</th>
                          <th>Account Name</th>
                          <th>Account Type</th>
                          <th>Savings</th>
                          <th>Shares</th>
                          <th>Fixed deposit</th>

                          <th>Savings interest</th>


                          <th>Savings Loan Security</th>
                          <th>Shares Loan Security</th>
                          <th>Loan</th>
                          <th>Loan interest</th>

                        </tr>
                      </thead>
                      <tbody>
                      {this.props.members.map(
                        (item)=>(
                          <tr>
                                                      <td>{item.no}</td>

                          <td>{item.AccountNumber}</td>
                          <td>{item.FullName}</td>
                          <td>{item.membertypename}</td>
                          <td className="align-right">{<CurrencyFormat value={Number(item.savings_balance || 0).toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={Number(item.sharesamount_balance || 0).toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={Number(item.fixed_deposit_balance || 0).toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                        
                          <td className="align-right">{<CurrencyFormat value={Number(item.saving_interestbalance || 0).toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>

                          <td className="align-right">{<CurrencyFormat value={Number(item.savingsloan_security_balance || 0).toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={Number(item.sharesloan_security_balance || 0).toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>

                          <td className="align-right">{<CurrencyFormat value={Number(item.loan_balance || 0).toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={Number(item.loaninterest_balance || 0).toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                          </tr>
                        ))}
                        <tr>
                        <td style={{fontWeight:'bolder'}}>Total</td>
                        <td></td>
                        <td></td>
                        <td></td>

                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.props.totalsavings.toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.props.totalshares.toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.props.totaldef.toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>

                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_saving_interestbalance().toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>

                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalsavingssec().toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalsharessec().toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>

                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_loanbalance().toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_loaninterestbalance().toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>

                        </tr>
                    </tbody>
                </reactstrp.Table> 
      </div>
    );
  }
}


class MemberSavingsReport extends React.Component {
  state = {
    ...initialReportEmailState(),
    searchText: '',
    searchedColumn: '',
    members: [],
    members_placeholder: [],

    viewpaymentmodal:false,
    expensedetails:{},
    companyprofile:{},
    userprofile:{},
    datarequested:true,
    memberactivationformvisible:false,
    selectedmemberid:'',
    date:moment().format(dateFormat).toString(),

    dateone:moment().format(dateFormat).toString(),
    datetwo:moment().format(dateFormat).toString(),
    search_by_range:false,
    mappingCount:0,
    mappingsVerified: false,
    reportLoadError: '',
    reportRequestFields: null,
    expandedMemberId: null,
    breakdownLoadingId: null,
    reportBasis: '',

  };

  loadLedgerMappingsCount = () => {
    if (!sacco) {
      return Promise.resolve();
    }
    return axios
      .get(`${serverconfig.backendserverurl}/api/member_subaccount_ledger_settings/?sacco=${sacco}`)
      .then((res) => {
        const active = (res.data || []).filter((row) => row.is_active && row.company_account);
        this.setState({
          mappingCount: active.length,
          mappingsVerified: true,
        });
      })
      .catch(() => {
        this.setState({ mappingsVerified: true });
      });
  };

  loadMemberSummaryReport = (fields) => {
    let form_data1 = new FormData();
    form_data1.append('sacco', sacco);
    form_data1.append('include_breakdown', '0');
    Object.keys(fields).forEach((key) => {
      form_data1.append(key, fields[key]);
    });

    submitReportWithEmail({
      reportKey: REPORT_KEYS.MEMBER_SUMMARY_PERIOD,
      params: { ...fields, sacco },
      emailReport: this.state.email_report,
      receivingEmail: this.state.receiving_email,
      endpoint: serverconfig.backendserverurl + '/customqueries/getMembersummaryreport_byperiod',
      formData: form_data1,
      setLoading: (v) => this.setState({
        datarequested: v,
        ...(v ? { reportLoadError: '', reportRequestFields: fields, expandedMemberId: null } : {}),
      }),
      onSuccess: (res) => {
        const members = JSON.parse(res.data.members_report).map((row) => ({
          ...row,
          breakdown: row.breakdown || [],
          breakdownLoaded: false,
        }));
        this.setState({
          members,
          members_placeholder: members,
          mappingCount: Number(res.data.mapping_count || this.state.mappingCount || 0),
          mappingsVerified: true,
          reportBasis: res.data.report_basis || '',
          reportLoadError: '',
        });
      },
      useInlineEmail: true,
    });
  };

  loadMemberBreakdown = (member) => {
    const fields = this.state.reportRequestFields;
    if (!fields || !member || member.breakdownLoaded) {
      return;
    }
    this.setState({ breakdownLoadingId: member.id });
    const form_data = new FormData();
    form_data.append('sacco', sacco);
    form_data.append('member_id', member.id);
    Object.keys(fields).forEach((key) => {
      form_data.append(key, fields[key]);
    });

    axios
      .post(
        serverconfig.backendserverurl + `/customqueries/getMemberSummaryBreakdown_byperiod`,
        form_data,
        { timeout: 120000 }
      )
      .then((res) => {
        const breakdown = res.data.breakdown || [];
        const merge = (list) =>
          list.map((row) =>
            row.id === member.id
              ? { ...row, breakdown, breakdownLoaded: true }
              : row
          );
        this.setState({
          members: merge(this.state.members),
          members_placeholder: merge(this.state.members_placeholder),
          reportBasis: res.data.report_basis || this.state.reportBasis,
          breakdownLoadingId: null,
        });
      })
      .catch((err) => {
        console.log(err);
        message.error('Failed to load GL breakdown for this member');
        this.setState({ breakdownLoadingId: null });
      });
  };

  toggleMemberBreakdown = (member) => {
    if (this.state.expandedMemberId === member.id) {
      this.setState({ expandedMemberId: null });
      return;
    }
    this.setState({ expandedMemberId: member.id });
    if (!member.breakdownLoaded) {
      this.loadMemberBreakdown(member);
    }
  };

  componentDidMount(){
      if(localStorage.getItem("sacco")){
        sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
        bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    }else{
        sacco= ''
        bizuserid= ''
    }
    
    if(localStorage.getItem("token")){
        token= localStorage.getItem("token")
    }else{
        token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {
      this.setState((prev) => ({
        companyprofile: res.data,
        receiving_email: prev.receiving_email || res.data.company_email || '',
      }));
    })

 

    this.loadLedgerMappingsCount().then(() => {
      this.loadMemberSummaryReport({
        date: this.state.date,
        action: "onboarding",
      });
    });

}

    //calculate total savings
    calculateTotalSavings=()=>{
      var Total=0
      this.state.members.map(
        (item)=>{
          Total+=Number(item.savings_balance)
        })
      return Total;

    }

    calculateTotalShares=()=>{
      var Total=0
      this.state.members.map(
        (item)=>{
          Total+=Number(item.sharesamount_balance)
        })
      return Total;

    }

    calculateTotalDef=()=>{
      var Total=0
      this.state.members.map(
        (item)=>{
          Total+=Number(item.fixed_deposit_balance)
        })
      return Total;

    }


    calculateTotalsavingssec=()=>{
      var Total=0
      this.state.members.map(
        (item)=>{
          Total+=Number(item.savingsloan_security_balance)
        })
      return Total;

    }

    calculateTotalsharessec=()=>{
      var Total=0
      this.state.members.map(
        (item)=>{
          Total+=Number(item.sharesloan_security_balance)
        })
      return Total;
    }


    calculateTotal_loanbalance=()=>{
      var Total=0
      this.state.members.map(
        (item)=>{
          Total+=Number(item.loan_balance)
        })
      return Total;
    }

    calculateTotal_loaninterestbalance=()=>{
      var Total=0
      this.state.members.map(
        (item)=>{
          Total+=Number(item.loaninterest_balance)
        })
      return Total;
    }

    //neww herees
    calculateTotal_saving_interestbalance=()=>{
      var Total=0
      this.state.members.map(
        (item)=>{
          Total+=Number(item.saving_interestbalance)
        })
      return Total;
    }


getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});


  render() {
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return(
        <div>
            <div style={{display: "none"}}>
               &nbsp;&nbsp;
              <ReportToPrint
              totalsavings={this.calculateTotalSavings()} 
              members={this.state.members}
              totaldef={this.calculateTotalDef()}
              totalshares={this.calculateTotalShares()}
              ref={el => (this.componentRef = el)} /> 
             </div>

            <Collapse defaultActiveKey={['1']} onChange={this.callback}>
            <Panel header={<h4 style={{fontWeight:'bolder'}}> MEMBER BALANCES REPORT BY {this.state.date}</h4>} key="1">

            <MemberBalancesJournalAlert
              mappingCount={this.state.mappingCount}
              mappingsVerified={this.state.mappingsVerified}
              reportLoadError={this.state.reportLoadError}
            />

            <div style={{display:'flex',justifyContent:'flex-start',alignSelf:'flex-start',alignItems:'flex-start'}}>
              {!this.state.email_report ? (
              <>
              <ReactToPrint
                trigger={() => 
                <Button type="primary"  shape="round" icon={<PrinterOutlined />} size={this.state.size}>
                Print
                </Button>
                }
                content={() => this.componentRef}
                />
                &nbsp;&nbsp;

          <ExcelFile filename={"Pisys - Member summary report. "} element={<Button type='primary' icon={<DownloadOutlined/>}>Download (Excel)</Button>}>
                <ExcelSheet data={this.state.members} name="Member summary report">
                    <ExcelColumn label="No" value="no"/>

                    <ExcelColumn label="Acc No" value="AccountNumber"/>
                    <ExcelColumn label="Acc Name" value="FullName"/>
                    <ExcelColumn label="Member type" value="membertypename"/>

                    <ExcelColumn label="Ordinary savings" value="savings_balance"/>
                    <ExcelColumn label="Share amount" value="sharesamount_balance"/>
                    <ExcelColumn label="Fixed deposit" value="fixed_deposit_balance"/>

                    <ExcelColumn label="Savings interest" value="saving_interestbalance"/>

                    <ExcelColumn label="Savings loan security" value="savingsloan_security_balance"/>
                    <ExcelColumn label="Shares loan security" value="sharesloan_security_balance"/>
                    <ExcelColumn label="Loan balance" value="loan_balance"/>
                    <ExcelColumn label="Loan interest balance" value="loaninterest_balance"/>

                </ExcelSheet>
            </ExcelFile>

            &nbsp;&nbsp;&nbsp;
              </>
              ) : null}

          <FormItem name="Search by range"
           label="search_by_range" >
            <Switch
                checked={this.state.search_by_range}
                onChange={val=>{this.setState({search_by_range:!this.state.search_by_range})}}
                checkedChildren="ON"
                unCheckedChildren="OFF"
                />
                  
          </FormItem>
          &nbsp;&nbsp;&nbsp;

          {
          this.state.search_by_range===true?
          <Form  layout="inline" >

          <FormItem label="Summary by (Date range)">
              <RangePicker onChange={
                (date, dateString) =>{
                  this.setState({ dateone: dateString[0]});
                  this.setState({ datetwo: dateString[1]});
                }
              } format={dateFormat} />
          </FormItem>


          <ReportEmailControls
            emailReport={this.state.email_report}
            receivingEmail={this.state.receiving_email}
            onEmailReportChange={(val) => this.setState({ email_report: val })}
            onReceivingEmailChange={(val) => this.setState({ receiving_email: val })}
            companyEmail={this.state.companyprofile.company_email}
          />

          <FormItem>
          <Button onClick={()=>{

          if(this.state.dateone==='' ){
          alert("Date one missing")
          }else if (this.state.datetwo==='' ){
            alert("Date two missing")
          } else{
          this.loadMemberSummaryReport({
            dateone: this.state.dateone,
            datetwo: this.state.datetwo,
            action: "daterange",
          });
          }

          }} type="primary" htmlType="button">{reportSearchButtonLabel(this.state.email_report)}</Button>
          </FormItem> 
          </Form>

          :
          <Form  layout="inline" >

          <FormItem label="Summary by (Date)">
              <DatePicker onChange={(date, dateString) =>{
              this.setState({ date: dateString});
            }} format={dateFormat} />
          </FormItem>


          <ReportEmailControls
            emailReport={this.state.email_report}
            receivingEmail={this.state.receiving_email}
            onEmailReportChange={(val) => this.setState({ email_report: val })}
            onReceivingEmailChange={(val) => this.setState({ receiving_email: val })}
            companyEmail={this.state.companyprofile.company_email}
          />

          <FormItem>
          <Button onClick={()=>{

          if(this.state.date==='' ){
          alert("Date one missing")
          }else{
          this.loadMemberSummaryReport({
            date: this.state.date,
            action: "onboarding",
          });
          }

          }} type="primary" htmlType="button">{reportSearchButtonLabel(this.state.email_report)}</Button>
          </FormItem> 
          </Form>

          }

        </div>
        <br />


            <br></br>
            <FormItem label="Search" >
            <Search
            placeholder="AccountNumber or AccountName"
            onChange={(value) => {
              var val=value.target.value
              console.log(val)
              if (val !== '') {
                const results = this.state.members.filter((request) => {
                  return request.FullName.toLowerCase().includes(val.toLowerCase());
                  // Use the toLowerCase() method to make it case-insensitive
                });
          
                if (results.length === 0) {
                  // this.setState({loanissues:this.state.loanissues_placeholder});

                  const results_2 = this.state.members.filter((request) => {
                    return request.AccountNumber.includes(val);
                    // Use the toLowerCase() method to make it case-insensitive
                  });

                  if (results_2.length === 0) {
                    this.setState({members:this.state.members_placeholder});

                  }else{
                    this.setState({members:results_2});

                  }

                } else {
                  this.setState({members:results});
                  console.log(results)
                }
          
              } else {
                this.setState({members:this.state.members_placeholder});
          
              }
          
            }}
            style={{
              width: 400,
            }}
            />
            </FormItem>
            <br />
            <br></br>


           <div style={{overflowX:'auto'}}>

           <reactstrp.Table bordered>
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>Breakdown</th>
                          <th>Account Number</th>
                          <th>Account Name</th>
                          <th>Account Type</th>
                          <th>Savings</th>
                          <th>Shares</th>
                          <th>Fixed deposit</th>

                          <th>Savings interest</th>

                          <th>Savings Loan Security</th>
                          <th>Shares Loan Security</th>
                          <th>Loan</th>
                          <th>Loan interest</th>

                        </tr>
                      </thead>
                      <tbody>
                      {this.state.members.map(
                        (item)=>(
                          <React.Fragment key={item.id || item.key}>
                          <tr>
                           <td>{item.no}</td>
                          <td>
                            <Button
                              type="link"
                              size="small"
                              loading={this.state.breakdownLoadingId === item.id}
                              icon={this.state.expandedMemberId === item.id ? <UpOutlined /> : <DownOutlined />}
                              onClick={() => this.toggleMemberBreakdown(item)}
                            >
                              {this.state.expandedMemberId === item.id ? 'Hide' : 'Show'}
                            </Button>
                          </td>

                          <td>{item.AccountNumber}</td>
                          <td>{item.FullName}</td>
                          <td>{item.membertypename}</td>
                          <td className="align-right"><MoneyCell value={item.savings_balance} /></td>
                          <td className="align-right"><MoneyCell value={item.sharesamount_balance} /></td>
                          <td className="align-right"><MoneyCell value={item.fixed_deposit_balance} /></td>
                        
                          <td className="align-right"><MoneyCell value={item.saving_interestbalance} /></td>

                          <td className="align-right"><MoneyCell value={item.savingsloan_security_balance} /></td>
                          <td className="align-right"><MoneyCell value={item.sharesloan_security_balance} /></td>

                          <td className="align-right"><MoneyCell value={item.loan_balance} /></td>
                          <td className="align-right"><MoneyCell value={item.loaninterest_balance} /></td>

                          </tr>
                          {this.state.expandedMemberId === item.id ? (
                            <tr>
                              <td colSpan={MEMBER_SUMMARY_COLUMN_COUNT}>
                                {this.state.breakdownLoadingId === item.id ? (
                                  <div style={{ padding: 24, textAlign: 'center' }}>
                                    <Spin />
                                  </div>
                                ) : (
                                  <MemberSummaryBreakdown
                                    breakdown={item.breakdown}
                                    reportBasis={this.state.reportBasis}
                                  />
                                )}
                              </td>
                            </tr>
                          ) : null}
                          </React.Fragment>
                        ))}
                        <tr>
                        <td style={{fontWeight:'bolder'}}>Total</td>
                        <td />
                        <td></td>
                        <td></td>
                        <td></td>

                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalSavings().toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalShares().toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalDef().toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>

                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_saving_interestbalance().toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>

                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalsavingssec().toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalsharessec().toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>

                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_loanbalance().toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotal_loaninterestbalance().toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>

                        </tr>

                    </tbody>
                </reactstrp.Table>  
           </div>
            
            </Panel>
            </Collapse>
        </div>
      )

    }

  }
}

export default MemberSavingsReport; 
